const stripHtml = function (content: string) {
  let domParser, strippedContent
  if (typeof window !== 'undefined') {
    domParser = new DOMParser()
    strippedContent = domParser.parseFromString(content.replace(/></g, '> <'), 'text/html').body.textContent
  } else {
    // eslint-disable-next-line @typescript-eslint/no-var-requires
    const striptags = require('striptags')
    strippedContent = striptags(content)
  }
  return strippedContent
}

export default {
  stripHtml: stripHtml
}
